export const getPersonTypeValue = (person) => {
  const rawType =
    person?.personType?.id ??
    person?.personTypeId?.id ??
    0;

  return Number(rawType || 0);
};

const buildTypeMismatchError = (expected, actualType) => {
  const actual = actualType || "unknown";
  const error = new Error(`Person type mismatch. Expected ${expected}, got ${actual}.`);
  error.response = {
    status: 404,
    data: {
      message: "البيانات المطلوبة غير موجودة",
    },
  };
  return error;
};

export const assertPersonType = (person, expectedType) => {
  const actualType = getPersonTypeValue(person);
  if (actualType !== expectedType) throw buildTypeMismatchError(expectedType, actualType);

  return actualType;
};

export const assertPersonTypeRange = (person, minType, maxType) => {
  const actualType = getPersonTypeValue(person);
  const isValid = actualType >= minType && actualType <= maxType;
  if (!isValid) throw buildTypeMismatchError(`${minType}-${maxType}`, actualType);

  return actualType;
};
